/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Marin GET /courses/unlink/:taskId/status — polls the LMS unpairing task.
 * Responds with { tracker: { status, successful } }.
 *
 * @file UnlinkCourseStatusService.js
 * @author Satyaki Bose
 */

import Framework, { BaseService } from '@greenville/framework';
import {
  COURSE_UNLINK_STATUS_REQUESTED,
  COURSE_UNLINK_STATUS_FETCHED,
  COURSE_UNLINK_STATUS_FAILED
} from '../../../common/constants';

export default class UnlinkCourseStatusService extends BaseService {
  constructor() {
    super(COURSE_UNLINK_STATUS_REQUESTED, 'courseUnlinkTaskStatus');
  }

  handleEvent(eventName, { taskId }) {
    return this.getClient('marin').get(`/courses/unlink/${taskId}/status`);
  }

  // eslint-disable-next-line class-methods-use-this
  handleResponse({ data }, { taskId } = {}) {
    // Status response has no taskId, so attach it for the poller to match against
    Framework.getEventManager().publish(COURSE_UNLINK_STATUS_FETCHED, { ...data?.tracker, taskId });
  }

  // eslint-disable-next-line class-methods-use-this
  handleError(error) {
    Framework.getEventManager().publish(COURSE_UNLINK_STATUS_FAILED, error);
  }
}
